import * as React from "react";
const SvgContactInformation = (props) => /* @__PURE__ */ React.createElement("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 23.48 15.59",
	width: "1em",
	height: "1em",
	...props
}, /* @__PURE__ */ React.createElement("defs", null), /* @__PURE__ */ React.createElement("g", {
	id: "contact_information_svg__Layer_2",
	"data-name": "Layer 2"
}, /* @__PURE__ */ React.createElement("g", {
	id: "contact_information_svg__Layer_1-2",
	"data-name": "Layer 1"
}, /* @__PURE__ */ React.createElement("path", {
	d: "M23.43.68a.9.9 0 0 0-.18-.32 1 1 0 0 0-.72-.36H1.59a1 1 0 0 0-.95.68A1 1 0 0 0 1 1.8l10.44 7.83a1 1 0 0 0 1.2 0L21.48 3v10.06h-8.14a1 1 0 0 0 0 2h9.14a1 1 0 0 0 1-1V1a1.3 1.3 0 0 0-.05-.32M12 7.58 4.59 2h14.89ZM6.32 13.07c-2.25.32-3.84-2.9-3.84-2.9l1-.72-1.4-2.08S-.22 8.42 0 10.1c.31 2.25 3.6 5.23 5.93 5.47s3.26-2.34 3.26-2.34l-2.47-1.36Z",
	style: { fill: "currentColor" }
}))));
export default SvgContactInformation;
